<template>
  <el-row :gutter="40" class="panel-group">
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="navigateToSpecies">
        <div class="card-panel-icon-wrapper icon-shopping">
          <svg-icon icon-class="cow" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            {{ $t('specie.species') }}
          </div>
          <count-to :start-val="0" :end-val="tableStats.species" :duration="3600" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="navigateToBreeds">
        <div class="card-panel-icon-wrapper icon-money">
          <svg-icon icon-class="animals" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            {{ $t('breed.breeds') }}
          </div>
          <count-to :start-val="0" :end-val="tableStats.breeds" :duration="3200" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="navigateToDiseases">
        <div class="card-panel-icon-wrapper icon-message">
          <svg-icon icon-class="disease" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            {{ $t('disease.diseases') }}
          </div>
          <count-to :start-val="0" :end-val="tableStats.diseases" :duration="3000" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="navigateToRegistrations">
        <div class="card-panel-icon-wrapper icon-people">
          <svg-icon icon-class="form" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            {{ $t('dashboard.registration') }}
          </div>
          <count-to :start-val="0" :end-val="tableStats.registrations" :duration="2600" class="card-panel-num" />
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import CountTo from 'vue-count-to';
import Resource from '@/api/resource';

const dashboardResource = new Resource('dashboard');

export default {
  components: {
    CountTo,
  },
  data() {
    return {
      tableStats: {},
    };
  },
  created() {
    this.fetchTableStats(); // Appel de la méthode lors de la création du composant
  },
  methods: {
    /* handleSetLineChartData(type) {
      this.$emit('handleSetLineChartData', type);
    }, */
    async fetchTableStats() {
      try {
        const { data } = await dashboardResource.sublist('/count-all-table-stats');
        this.tableStats = data;
      } catch (error) {
        console.error('Erreur lors de la récupération des statistiques des tables:', error);
      }
    },
    navigateToDiseases() {
      this.$router.push({ name: 'diseases' });
    },
    navigateToBreeds() {
      this.$router.push({ name: 'breeds' });
    },
    navigateToSpecies() {
      this.$router.push({ name: 'species' });
    },
    navigateToRegistrations() {
      this.$router.push({ name: 'registrations' });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group .card-panel-col {
    margin-bottom: 20px;
    // padding-right: 0px;
}
.panel-group {
  margin-top: 15px;
  .card-panel-col{
    margin-bottom: 20px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 13px;
    position: relative;
    /* overflow: hidden; */
    /*color: #666;*/
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
         background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shopping {
        background: #34bfa3
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shopping {
      color: #34bfa3
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 18px 6px 0 10px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 35px;
    }
    .card-panel-description {
      float: left;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        /* color: rgba(0, 0, 0, 0.45);*/
        font-size: 20px;
        margin-bottom: 10px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
</style>
